module.exports = __webpack_public_path__ + "img/logo-sambamaniacos-2020.5b9cff1a.png";